import { render } from "./TermCondition.vue?vue&type=template&id=37ad5656&scoped=true"
import script from "./TermCondition.vue?vue&type=script&lang=js"
export * from "./TermCondition.vue?vue&type=script&lang=js"

import "./TermCondition.vue?vue&type=style&index=0&id=37ad5656&scoped=true&lang=css"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37ad5656"]])

export default __exports__